import { render } from "./NotaFiscalDocumentosReferenciados.vue?vue&type=template&id=936fd434&scoped=true&ts=true"
import script from "./NotaFiscalDocumentosReferenciados.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalDocumentosReferenciados.vue?vue&type=script&lang=ts"

import "./NotaFiscalDocumentosReferenciados.vue?vue&type=style&index=0&id=936fd434&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-936fd434"]])

export default __exports__